import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AcuerdoAmbitoGeograficoControllerService,
  AcuerdoAmbitoGeograficoDTO,
  CodigoLerControllerService,
  CodigoLerFilterDTO,
  ComunidadControllerService,
} from 'api-rest';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'managers-agreements-geographic-scope-dialog',
  templateUrl: './geographic-scope-dialog.component.html',
  styleUrls: ['./geographic-scope-dialog.component.scss']
})
export class GeographicScopeDialogComponent implements OnInit {
  ambitoGeografico: any;
  acuerdoIndirecto!: any;
  titulo = '';
  formGroup!: FormGroup;
  comunidades: any[] = [];
  codigosLer: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<GeographicScopeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private acuerdoAmbitoGeograficoControllerSrv: AcuerdoAmbitoGeograficoControllerService,
    private comunidadControllerSrv: ComunidadControllerService,
    private codigoLerControllerSrv: CodigoLerControllerService,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService,
  ) {
    this.ambitoGeografico = this.data.ambitoGeografico;
    this.acuerdoIndirecto = this.data.acuerdoIndirecto;
    this.formGroup = this.formBuilder.group({
      comunidad: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      codigoLer: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      cantidad_t: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.min(0)]) },
      ],
    });
  }

  ngOnInit(): void {
    if (this.ambitoGeografico) {
      this.titulo = 'Editar ámbito geográfico';
      this.cargarAmbitoGeografico(this.ambitoGeografico);
    } else {
      this.titulo = 'Nuevo ámbito geográfico';
    }
    this.getComboComunidad();
    this.buscaCodigoLer();
  }

  cargarAmbitoGeografico(ambitoGeografico: AcuerdoAmbitoGeograficoDTO): void {
    if (!ambitoGeografico) return;
    this.formGroup.patchValue({
      comunidad: ambitoGeografico?.comunidad?.id,
      codigoLer: ambitoGeografico?.codigoLer?.id,
      cantidad_t: ambitoGeografico?.cantidad_t,
    });
  }

  getComboComunidad() {
    this.comunidadControllerSrv
      .listarComunidades3({}, { page: 0, size: 500, sort: [] })
      .subscribe({
        next: (data: any) => {
          this.comunidades = data.datos ?? [];
        },
        error: () => {},
      });
  }

  buscaCodigoLer() {
    const filtro: CodigoLerFilterDTO = {
      acuerdoGestores: true,
    };
    this.codigoLerControllerSrv.findAll4(filtro, { page: 0, size: 1000 }).subscribe({
      next: (res) => {
        this.codigosLer = res?.datos ?? [];
      },
      error: () => {},
    });
  }

  comprobarGuardar() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.valid) {
      this.guardar();
    } else {
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
    }
  }

  guardar() {
    const comunidadSel = this.comunidades.find(
      (x) => x.id === this.formGroup.get('comunidad')?.value
    );
    const codigoLerSel = this.codigosLer.find(
      (x) => x.id === this.formGroup.get('codigoLer')?.value
    );

    const editAmbitoGeografico: AcuerdoAmbitoGeograficoDTO = {
      id: this.ambitoGeografico?.id ?? undefined,
      acuerdoIndirecto: this.acuerdoIndirecto,
      comunidad: comunidadSel,
      codigoLer: codigoLerSel,
      cantidad_t: this.formGroup.get('cantidad_t')?.value,
    };

    this.spinnerSrv.loadingShow();
    if (this.ambitoGeografico) {
      this.acuerdoAmbitoGeograficoControllerSrv
        .updateById1(this.ambitoGeografico.id!, editAmbitoGeografico)
        .subscribe({
          next: () => this.handleSuccess(),
          error: () => this.handleError(),
        });
    } else {
      this.acuerdoAmbitoGeograficoControllerSrv
        .create3(editAmbitoGeografico)
        .subscribe({
          next: () => this.handleSuccess(),
          error: () => this.handleError(),
        });
    }
  }

  handleSuccess() {
    this.spinnerSrv.loadingHide();
    this.snackBarSrv.showSnackBar(
      'Datos de ámbito geográfico guardados correctamente',
      'success'
    );
    this.dialogRef.close(true);
  }

  handleError() {
    this.spinnerSrv.loadingHide();
    this.snackBarSrv.showSnackBar(
      'Ya existe un código LER para la comunidad seleccionada',
      'error'
    );
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }
}
